// extracted by mini-css-extract-plugin
export default {"forgotPassword":"ForgotPasswordButton_forgotPassword__shxWx"};